var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoRight',{ref:"right",attrs:{"reportId":_vm.reportId,"scantron":_vm.scantron,"answer":_vm.answer,"current":_vm.current,"allowPause":false,"storeKey":"homework-seconds","hasNotSupport":false,"shotAnswerEditable":"","submitTopicFunc":_vm.submitTopic},on:{"getTopic":_vm.onGetTopic,"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }